import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { RouteWiseCropDetailsReport } from './Pages';

export const RouteWiseCropDetailsReportRoutes = ({ match }) => (
    <Fragment>
        <Route exact path = {`${match.path}`} component={RouteWiseCropDetailsReport} />
    </Fragment>
)